import { render, staticRenderFns } from "./RemoteConfiguration.vue?vue&type=template&id=6f2e6ee2&scoped=true&"
import script from "./RemoteConfiguration.vue?vue&type=script&lang=ts&"
export * from "./RemoteConfiguration.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f2e6ee2",
  null
  
)

export default component.exports